import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  LayoutDashboard,
  Settings,
  Users,
  Bell,
  ClipboardList,
  MapPin,
  Power,
  ChevronLeft,
  Menu,
  Banknote,
  BarChartBig,
  LucideShoppingCart,
  CalendarClock,
  BadgePercent,
  CalendarCheck,
  ListChecks,
  Crown,
  UserCircle,
  IndianRupee,
  Wifi,
  WifiOff,
} from "lucide-react";

import { useGlobalContext } from "../GlobalContext";
import Logo from "../Images/Packky.svg";
import Logo1 from "../Images/P.svg";
import ConfirmLogoutModal from "./Utils/ConfirmLogoutModal";

const iconMap = {
  Dashboard: LayoutDashboard,
  Tasks: ClipboardList,
  Reports: BarChartBig,
  Driver: UserCircle,
  Teams: Users,
  Slots: ListChecks,
  Settings: Settings,
  Banks: IndianRupee,
  Notifications: Bell,
  Shops: LucideShoppingCart,
  Tiers: Crown,
  Tier: BadgePercent,
  Notification: Bell,
  Attendance: CalendarCheck,
};

const sidebarItems = [
  { name: "Dashboard", icon: LayoutDashboard },
  { name: "Tasks", icon: ClipboardList },
  { name: "Reports", icon: BarChartBig },
  { name: "Driver", icon: MapPin },
  { name: "Teams", icon: Users },
  { name: "Slots", icon: CalendarClock },
  { name: "Settings", icon: Settings },
  { name: "Banks", icon: Banknote },
  { name: "Notifications", icon: Bell },
  { name: "Shops", icon: LucideShoppingCart },
  { name: "Tier", icon: BadgePercent },
];

export default function Sidebar({ sidebarOpen, setSidebarOpen }) {
  const { baseurl, token, accessToken, setIsUnauthorised, AdminId } =
    useGlobalContext();

  const navigate = useNavigate();
  const location = useLocation();
  const [menuItems, setMenuItems] = useState([]);

  const { logoutAdmin } = useGlobalContext();

  const handleAdminLogout = () => {
    logoutAdmin();
    navigate("/login", { replace: true });
  };
  const [volunteerInfo, setVolunteerInfo] = useState(null);
  const [isOnline, setIsOnline] = useState(true);
  useEffect(() => {
    try {
      const raw = sessionStorage.getItem("admin");
      if (raw) {
        const parsed = JSON.parse(raw);
        setVolunteerInfo(parsed);
      }
    } catch (error) {
      console.error("Failed to parse volunteerData from session", error);
    }
  }, []);
  const VolunteerStatusCard = ({ collapsed = false }) => {
    if (!volunteerInfo) return null;

    const name = volunteerInfo?.userName || "Volunteer";
    const role =
      volunteerInfo?.role || volunteerInfo?.userType || "User";

    if (collapsed) {
      return (
        <div className="px-2 pb-3">
          <div className="rounded-2xl bg-white/14 border border-white/20 p-2 flex flex-col items-center gap-2">
            <div className="h-9 w-9 rounded-full bg-white text-[#FC981B] flex items-center justify-center font-bold text-sm shadow-sm">
              {name?.charAt(0)?.toUpperCase() || "V"}
            </div>

            {/* <button
              type="button"
              onClick={() => setIsOnline((prev) => !prev)}
              className={`h-7 w-7 rounded-full flex items-center justify-center transition ${isOnline
                  ? "bg-emerald-500 text-white"
                  : "bg-slate-500 text-white"
                }`}
              title={isOnline ? "Online" : "Offline"}
            >
              {isOnline ? <Wifi size={14} /> : <WifiOff size={14} />}
            </button> */}
          </div>
        </div>
      );
    }

    return (
      <div className="px-3 pb-3">
        <div className="rounded-2xl border border-white/20 bg-white/14 backdrop-blur-md p-3 shadow-sm">
          <div className="flex items-start gap-3">
            <div className="h-11 w-11 rounded-full bg-white text-[#FC981B] flex items-center justify-center font-bold text-base shadow-sm shrink-0">
              {name?.charAt(0)?.toUpperCase() || "V"}
            </div>

            <div className="min-w-0 flex-1">
              <div className="text-sm font-semibold text-white truncate">
                {name}
              </div>
              <div className="text-[11px] text-white/75 truncate mt-0.5">
                {role}
              </div>
            </div>
          </div>

          <div className="mt-3 flex items-center justify-between rounded-xl bg-white/10 px-3 py-2">
            <div className="flex items-center gap-2">
              <span
                className={`h-2.5 w-2.5 rounded-full ${isOnline ? "bg-emerald-400" : "bg-slate-300"
                  }`}
              />
              <span className="text-xs font-medium text-white">
                {isOnline ? "Online" : "Offline"}
              </span>
            </div>

            {/* <button
              type="button"
              onClick={() => setIsOnline((prev) => !prev)}
              className={`relative h-6 w-11 rounded-full transition-all ${isOnline ? "bg-emerald-500" : "bg-white/30"
                }`}
            >
              <span
                className={`absolute top-[2px] h-5 w-5 rounded-full bg-white shadow transition-all ${isOnline ? "left-[22px]" : "left-[2px]"
                  }`}
              />
            </button> */}
          </div>
        </div>
      </div>
    );
  };
  useEffect(() => {
    const fetchAccessMenu = async () => {
      try {
        const res = await fetch(`${baseurl}/api/Admin/v1.0/getUserAccess`, {
          method: "POST",
          headers: {
            Authorization: `Basic ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ userid: AdminId }),
        });

        const data = await res.json();
        if (data.responseCode === "00") {
          setMenuItems(
            data.response.filter((item) => item.menu_title && item.menu_url),
          );
        } else if (data.responseCode === "401") {
          setIsUnauthorised(true);
        }
      } catch (err) {
        console.error("Error fetching menu access", err);
      }
    };

    fetchAccessMenu();
  }, []);

  return (
    <>
      {/* Mobile Toggle Button - Only visible on mobile */}
      <button
        onClick={() => setSidebarOpen(!sidebarOpen)}
        className="md:hidden fixed top-4 right-4 z-50 p-2 rounded-lg shadow-lg"
        style={{
          backgroundColor: "#FC981B",
          color: "#ffff",
        }}
      >
        <Menu size={13} />
      </button>

      {/* Mobile Top Navigation - Only visible on mobile when sidebar is open */}
      {sidebarOpen && (
        <>
          {/* Mobile Overlay */}
          <div
            className="md:hidden fixed inset-0   z-30"
            onClick={() => setSidebarOpen(false)}
          />

          {/* Mobile Top Nav */}
          <div
            className="md:hidden fixed top-0 left-0 right-0 z-40 p-2 pt-2"
            style={{
              backgroundColor: "#FC981B",
              color: "#ffff",
              fontWeight: "600",
            }}
          >
            {/* Header with logo and close button */}
            <div className="flex items-center justify-between mb-4">
              <div
                className="h-10 content-center"
                style={{
                  padding: "10px",
                  backgroundColor: "white",
                  borderRadius: "1.5rem",
                }}
              >
                <img className="h-6" src={Logo} alt="" />
              </div>

              <button
                onClick={() => setSidebarOpen(false)}
                className="p-1 rounded-full hover:bg-white/20 transition-colors"
              >
                {/* <X size={24} /> */}
              </button>
            </div>

            {/* Navigation Menu - Horizontal scroll on mobile */}
            <div
              className="block md:hidden flex overflow-x-auto space-x-2 px-2 py-1 scrollbar-hide bg-[#FC981B] text-white text-sm"
              style={{ height: "52px" }}
            >
              {menuItems.map((item) => {
                const routePath = item.menu_url;
                const isActive = location.pathname === routePath;
                const Icon = iconMap[item.menu_title] || LayoutDashboard;

                return (
                  <div
                    key={item.menu_title}
                    onClick={() => {
                      navigate(routePath);
                      setSidebarOpen(false);
                    }}
                    className={`flex flex-col items-center justify-center px-2 cursor-pointer rounded-lg transition-all ${isActive ? "bg-white bg-opacity-20" : "hover:bg-white/20"
                      }`}
                    style={{ minWidth: "54px" }}
                  >
                    <Icon size={14} />
                    <span className="text-[10px]">{item.menu_title}</span>
                  </div>
                );
              })}

              <ConfirmLogoutModal
                onConfirm={handleAdminLogout}
                trigger={
                  <div className="flex items-center space-x-2 cursor-pointer hover:bg-red-500 transition-colors p-2 rounded text-white">
                    <Power size={20} />
                    {sidebarOpen && <span>Logout</span>}
                  </div>
                }
              />
            </div>
          </div>
        </>
      )}

      {/* Desktop/Tablet Sidebar - Hidden on mobile, visible on md and up */}
      <div
        className={`hidden md:flex ${sidebarOpen ? "w-56" : "md:w-16"
          } transition-all duration-200 ease-in-out flex-col h-full shadow-lg`}
        style={{
          backgroundColor: "#FC981B",
          color: "#ffff",
          fontWeight: "600",
        }}
      >
        <div className="flex items-center justify-between p-4 border-b border-red-700">
          <span className="text-lg font-bold whitespace-nowrap">
            {sidebarOpen ? (
              <div
                className="h-15 content-center"
                style={{
                  padding: "15px",
                  backgroundColor: "white",
                  borderRadius: "2rem",
                }}
              >
                <img className="h-7" src={Logo} alt="" />
              </div>
            ) : (
              ""
            )}
          </span>

          {/* Desktop toggle button */}
          <button
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="p-1 rounded-full hover:bg-white/20 transition-colors"
          >
            {sidebarOpen ? (
              <ChevronLeft size={20} />
            ) : (
              <div className=" bg-white rounded">
                <img className=" bg-white rounded " src={Logo1} alt="" />
              </div>
            )}
          </button>
        </div>

        <div className="flex-1 py-2 space-y-2">
          {menuItems.map((item) => {
            const routePath = item.menu_url;
            const isActive = location.pathname === routePath;
            const Icon = iconMap[item.menu_title] || LayoutDashboard;

            return (
              <div
                key={item.menu_title}
                onClick={() => navigate(routePath)}
                title={!sidebarOpen ? item.menu_title : ""}
                className={`flex items-center space-x-2 p-2 cursor-pointer transition-all ${isActive
                    ? "bg-white bg-opacity-20 border-l-4 border-white"
                    : "hover:bg-white/20"
                  }`}
                style={{ paddingLeft: isActive ? "12px" : "16px" }}
              >
                <Icon size={20} />
                {sidebarOpen && <span>{item.menu_title}</span>}
              </div>
            );
          })}
        </div>

       <div className="border-t border-white/20 pt-3">
  <VolunteerStatusCard collapsed={!sidebarOpen} />

  <div className="px-3 pb-4">
    <ConfirmLogoutModal
      onConfirm={handleAdminLogout}
      trigger={
        <div className="flex items-center justify-center gap-2 cursor-pointer rounded-xl border border-white/15 bg-white/10 hover:bg-red-500 transition-all px-3 py-2 text-white">
          <Power size={18} />
          {sidebarOpen && <span className="text-sm font-medium">Logout</span>}
        </div>
      }
    />
  </div>
</div>
      </div>
    </>
  );
}
